import * as React from 'react'
import './flokkar-product.css'
import { LightBox } from 'src/components/Shared/lightbox'
import icelandicReplace from 'src/components/Shared/Icelandic'

interface IState {
  companyName: any
  companyUrl: any
  isOpen: boolean
  isSpecial: boolean
  images: any
  line: string
  fromUrl: boolean
  fromLightbox: boolean
  originalPath: string
}
export default class FlokkarProduct extends React.Component<any, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      companyName: null,
      companyUrl: null,
      fromLightbox: false,
      fromUrl: this.props.lina !== undefined,
      images: null,
      isOpen: false,
      isSpecial: false,
      line: '',
      originalPath: '',
    }
    this.setImages = this.setImages.bind(this)
    this.closeLightBox = this.closeLightBox.bind(this)
  }

  setImages(content: any, key: string, secondKey: string) {
    this.setState({
      companyName: content[0].fields.vrumerki[key].fields.nafn,
      companyUrl: content[0].fields.vrumerki[key].fields.url,
      fromUrl: false,
      images: content[0].fields.vrumerki[key].fields.linur[secondKey].fields,

      isOpen: true,
      isSpecial:
        content[0].fields.nafn === 'Parket' ||
        content[0].fields.nafn === 'Harðparket'
          ? true
          : false,
      line: icelandicReplace(
        content[0].fields.vrumerki[key].fields.linur[secondKey].fields
          .nafnALinu,
      ),
      originalPath: icelandicReplace(
        `/vorur/${content[0].fields.nafn}/${content[0].fields.vrumerki[key].fields.nafn}`,
      ),
    })

    window.history.pushState(
      '',
      '',
      icelandicReplace(
        `/vorur/${content[0].fields.nafn}/${content[0].fields.vrumerki[key].fields.nafn}/${content[0].fields.vrumerki[key].fields.linur[secondKey].fields.nafnALinu}`,
      ),
    )
  }
  closeLightBox() {
    document.getElementsByTagName('html')[0].style.overflow = 'initial'
    window.history.pushState('', '', `${this.state.originalPath}`)
    document?.getElementById(this.state.line)?.scrollIntoView()
    this.setState({
      fromLightbox: true,
      fromUrl: false,
      images: null,
      isOpen: false,
      line: '',
    })
  }

  render() {
    const location = this.props.location
    let content = this.props.content

    const vorumerki = this.props.vorumerki
    const lina = this.props.lina

    if (content !== undefined) {
      content = content.filter(
        (l: any) => icelandicReplace(l.fields.nafn) === location,
      )
    }

    if (content !== undefined && lina !== undefined && this.state.fromUrl) {
      // open lightbox with correct images
      Object.keys(content[0]?.fields?.vrumerki).map((key) => {
        if (content[0].fields?.vrumerki[key]?.fields?.linur !== undefined) {
          Object.keys(content[0].fields?.vrumerki[key]?.fields?.linur).map(
            (secondKey) => {
              if (
                icelandicReplace(
                  content[0].fields.vrumerki[key]?.fields?.linur[secondKey]
                    ?.fields?.nafnALinu,
                ) === lina
              ) {
                this.setImages(content, key, secondKey)
              }
            },
          )
        }
      })
    }

    if (
      content !== undefined &&
      vorumerki !== undefined &&
      lina === undefined &&
      !this.state.fromLightbox
    ) {
      // go to vorumerki
      setTimeout(
        () => document?.getElementById(vorumerki)?.scrollIntoView(),
        50,
      )
    }

    return (
      <div className="flokkar-product-container">
        {content !== undefined &&
          content[0]?.fields !== undefined &&
          Object.keys(content[0]?.fields?.vrumerki).map((key) => {
            if (
              content[0]?.fields?.vrumerki[key]?.fields?.linur !== undefined
            ) {
              return (
                <div key={key}>
                  <div className="item-container flokkar-product-container-header">
                    <div
                      className="flokkar-product-header"
                      id={icelandicReplace(
                        content[0].fields.vrumerki[key]?.fields?.nafn,
                      )}
                    >
                      {content[0].fields.vrumerki[key]?.fields?.nafn}
                    </div>
                    <button className="catalogue">
                      <a
                        href={content[0].fields.vrumerki[key]?.fields?.url}
                        target="_blank"
                      >
                        Vefur framleiðanda
                      </a>
                    </button>
                  </div>
                  <div className="item-container flokkar-product-container-items">
                    {content[0].fields.vrumerki[key]?.fields?.linur !==
                      undefined &&
                      Object.keys(
                        content[0].fields.vrumerki[key]?.fields?.linur,
                      ).map((secondKey) => {
                        /*const correctClassName =
                                parseInt(key, 10) !== content.length - 1
                                    ? 'instagram-image instagram-gutter'
                                    : 'instagram-image ';*/
                        return (
                          <>
                            {content[0].fields.vrumerki[key]?.fields?.linur[
                              secondKey
                            ]?.fields?.images !== undefined &&
                              Object.keys(
                                content[0].fields.vrumerki[key]?.fields?.linur[
                                  secondKey
                                ]?.fields?.images,
                              ).map((thirdkey) => {
                                if (thirdkey === '0') {
                                  return (
                                    <div
                                      className="items-4 products"
                                      key={secondKey}
                                      id={icelandicReplace(
                                        content[0].fields.vrumerki[key].fields
                                          .linur[secondKey].fields?.nafnALinu,
                                      )}
                                      onClick={() =>
                                        this.setImages(content, key, secondKey)
                                      }
                                    >
                                      <div className="flokkar-product-line-images">
                                        <div
                                          className="flokkar-product-first-image"
                                          style={{
                                            backgroundImage:
                                              'url(' +
                                              content[0].fields.vrumerki[key]
                                                ?.fields.linur[secondKey]
                                                ?.fields.images[thirdkey].fields
                                                ?.file?.url +
                                              ')',
                                          }}
                                        />
                                        <div
                                          className="flokkar-product-second-image"
                                          style={{
                                            backgroundImage:
                                              'url(' +
                                              content[0].fields.vrumerki[key]
                                                ?.fields.linur[secondKey]
                                                ?.fields.vrumynd?.fields?.file
                                                ?.url +
                                              ')',
                                          }}
                                        />
                                      </div>
                                      <div className="flokkar-product-line-name">
                                        {
                                          content[0].fields.vrumerki[key].fields
                                            .linur[secondKey].fields?.nafnALinu
                                        }
                                      </div>
                                    </div>
                                  )
                                } else {
                                  return <></>
                                }
                              })}
                          </>
                        )
                      })}
                  </div>
                </div>
              )
            } else {
              return <div key={key} />
            }
          })}
        {this.state.isOpen && (
          <LightBox
            content={this.state.images}
            cancel={this.closeLightBox}
            companyName={this.state.companyName}
            companyUrl={this.state.companyUrl}
            isSpecial={this.state.isSpecial}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product-page/flokkar-product/flokkar-product.tsx